import React, { useState, useEffect, useRef } from "react";


function InstantNIDDropDown(props) {
    const {
        label,
        name,
        id,
        fieldId,
        isRequired,
        errId,
        divClass,
        options,
        fieldName,
        fieldValue,
        handleSelectChange,
        checkDetailsIndex,
        hasError = null,
        isDisabled,
        activeCaseCheck
    } = props;

    const [fieldVal, setFieldVal] = useState('');

    const handleOnChange = (e) => {
        const selectedOption = options.find(option => option?.label === e?.target?.value)
        handleSelectChange(selectedOption);
        setFieldVal('');
    };

    useEffect(() => {
 
    }, [fieldValue])

    const errorMsg =
        (fieldValue == null || fieldValue == "") && isRequired == 1
            ? "This is a required field."
            : "Please provide valid input";

    return (
        <>
            <div className="col-sm-12 col-md-12 col-xl-12 mt-3">
                <div className="form-group">
                    <div className="floating-label tp-dropdown">
                        <select
                            name={name}
                            id={id}
                            className="form-control"
                            onChange={(e) => handleOnChange(e)}
                            data-checkdetailsindex={checkDetailsIndex}
                            data-fieldname={fieldName}
                            // ref={inputText}
                            value={fieldValue || fieldVal}
                            disabled={isDisabled || false}
                        > 
                        <option value="" disabled selected={!fieldValue || !options?.length}>Select Option</option>
                            {
                               options?.length && options?.map((option) => {
                                if(!(option?.case_check_id && activeCaseCheck?.case_check_id !== option?.case_check_id)) {
                                    return (
                                        <option
                                            value={option?.label}
                                            selected={fieldValue == option?.label ? true : false}
                                            disabled={option?.case_check_id && activeCaseCheck?.case_check_id !== option?.case_check_id  ? true :  false}
                                        >
                                            {option?.label}
                                        </option>
                                    );
                                } else {
                                    return <></>
                                }

                                })
                            }

                        </select>
                        <label htmlFor={id} className={"focused"}>
                            {label}
                            {isRequired == 1 && <sup className="text-danger">*</sup>}
                        </label>
                    </div>
                    {hasError && hasError === true && (
                        <p className="err text-danger" id={errId}>
                            {errorMsg}
                        </p>
                    )}
                </div>
            </div>
        </>
    );
}

export default InstantNIDDropDown;